export default __webpack_public_path__ + "static/plus-664f61a16ae1aa66409942af0bbdb16e.svg";